import webService from './web-service';
import apiService from './api-service';
const Auth = {};

Auth.getUser = () => {
    return webService.get(`/getuser`)
        .then((res) => res)
        .catch((error) => error.response.data);
};

Auth.getAuth = () => {
    return apiService.get(`/user`)
        .then((res) => res)
        .catch((error) => error.response.data);
};

Auth.autentication = () => {
    return webService.get(`/sanctum/csrf-cookie`)
        .then((res) => res)
        .catch((error) => error.response.data);
};
Auth.csrf = (data) => {
    return webService.get('/sanctum/csrf-cookie', data)
        .then((res) => res);
};
Auth.login = (data) => {
    return webService.post('/login', data)
        .then((res) => res);
};

Auth.logout = (data) => {
    return webService.post('/logout', data)
        .then((res) => res);
};

export default Auth;
